import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $libraryFavoritesTvChannelsTranslations = combine(
  i18n.$t,
  ({ t }) => ({
    liveChannels: t('channel_favorites'),
  })
)
